import InsertNewLineDialog from './insertNewLineDialog'
export default InsertNewLineDialog
